import React from 'react';
import { Card } from '@ygtechnologies/rubus-ui';
import { Breadcrumbs } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { OptionGroupWizard } from './OptionGroupWizard/OptionGroupWizard';
import { useGetProjectId } from '@/utils/hooks';
import { useHistory, useParams } from 'react-router';
import { toNullableNumber } from '@/utils/html';
import { PageTitle } from '@/components/layout/PageTitle';
import { BreadcrumbsProjectLink } from '@/components/navigation';
import theme from './OptionGroupsCreatePage.module.scss';

export interface OptionGroupsCreatePageProps { }
export interface OptionGroupsCreatePageParams {
    sourceOptionGroupId: string;
}

export const OptionGroupsCreatePage: React.FC<OptionGroupsCreatePageProps> = ({ }) => {
    const projectId = useGetProjectId();
    const params = useParams<OptionGroupsCreatePageParams>();
    const sourceOptionGroupId = toNullableNumber(params.sourceOptionGroupId);
    const history = useHistory();

    const goToOptions = () => {
        history.push(`/projects/${projectId}/options`);
    };

    const title = sourceOptionGroupId ? <Trans>Duplicate option group</Trans> : <Trans>New option group</Trans>;

    return (
        <Card className={theme.container}>
            <PageTitle>{title}</PageTitle>

            <Breadcrumbs>
                <BreadcrumbsProjectLink to="/options">
                    <Trans>Options</Trans>
                </BreadcrumbsProjectLink>
                <Breadcrumbs.Item>{title}</Breadcrumbs.Item>
            </Breadcrumbs>

            <OptionGroupWizard
                projectId={projectId!}
                sourceOptionGroupId={sourceOptionGroupId}
                onSubmit={goToOptions}
                onCancel={goToOptions}
            />
        </Card>
    );
};
